<script setup lang="ts">
type LinkItem = {
  label: string;
  to?: string;
};

withDefaults(defineProps<{
  title?: string;
  links: LinkItem[];
}>(), {
  title: "",
});
</script>

<template>
  <div class="rounded-[22px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-950/40">
    <h3 v-if="title" class="text-lg font-semibold text-slate-900 dark:text-white">{{ title }}</h3>
    <div class="mt-3 space-y-2">
      <template v-for="link in links" :key="`${link.to || 'text'}-${link.label}`">
        <NuxtLink
          v-if="link.to"
          :to="link.to"
          class="block rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium leading-6 text-slate-700 transition hover:border-amber-300 hover:text-amber-800 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:border-amber-700 dark:hover:text-amber-300"
        >
          {{ link.label }}
        </NuxtLink>
        <p
          v-else
          class="block rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm leading-6 text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
        >
          {{ link.label }}
        </p>
      </template>
    </div>
  </div>
</template>
